import React from 'react';

import { Avatar } from '@mui/material';

const MarketingKpiCard = ({ accent, comparisonLabel, delta, icon, label, splits, value }) => (
    <div className='crm-dashboard-metric-card marketing-kpi-card' style={{ '--metric-accent': accent }}>
        <div className='crm-dashboard-metric-header'>
            <p className='crm-dashboard-eyebrow crm-dashboard-metric-label'>{label}</p>
            <Avatar className='crm-dashboard-metric-avatar'>{icon}</Avatar>
        </div>
        <h3 className='crm-dashboard-metric-value' title={value}>{value}</h3>
        <p className='marketing-kpi-foot'>
            <span className={`marketing-kpi-delta is-${delta.tone}`}>{delta.text}</span>
            <span className='marketing-kpi-comparison' title={comparisonLabel}>vs {comparisonLabel}</span>
        </p>
        <ul className='marketing-kpi-split'>
            {splits.map((split) => (
                <li key={split.label}>
                    <i style={{ background: split.color }} />
                    <span>{split.label}</span>
                    <b>{split.value}</b>
                    <span className={`marketing-kpi-delta is-${split.delta.tone}`}>{split.delta.text}</span>
                </li>
            ))}
        </ul>
    </div>
);

export default MarketingKpiCard;
